<script>
	export let frontend_endpoint;
	export let backend_endpoint;
	export let token;
	export let username;
	export let roles;

	import { setContext } from "svelte";
	import { api_info } from "./api/client.js";
	import { Router, Route } from "svelte-navigator";
	import HomePage from "./routes/HomePage.svelte";
	import UserPage from "./routes/UserPage.svelte";
	import ReviewPage from "./routes/ReviewPage.svelte";
	import AdminPage from "./routes/AdminPage.svelte";
	import RearrangeTagsPage from "./routes/RearrangeTagsPage.svelte";
	import EditDataPage from "./routes/EditDataPage.svelte";
	import Navigation from "./components/Navigation.svelte";
	import Version from "./components/Version.svelte";

	setContext(api_info, {
		frontend_endpoint,
		backend_endpoint,
		token,
		username,
	});

	window.feVersion = "v1.5";
</script>

<div class="container" id="main-container">
	<Navigation {username} {roles} />
	<div id="main-div" class="with-margins">
		<Router>
			<Route path="/">
				<HomePage {username} />
			</Route>
			<Route path="/user_page">
				<UserPage />
			</Route>
			<Route path="/review_page">
				<ReviewPage />
			</Route>
			<Route path="/admin_page">
				<AdminPage />
			</Route>
			<Route path="/rearrange_tags">
				<RearrangeTagsPage />
			</Route>
			<Route path="/edit_data">
				<EditDataPage />
			</Route>
		</Router>
	</div>
	{#if username}
		<Version />
	{/if}
</div>
